import { DxSharedModule } from './../../shared/dx-shared.module';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleCardComponent } from './single-card/single-card.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { HeaderComponent } from './components/header/header.component';
import { UserPanelComponent } from './components/user-panel/user-panel.component';
import { SideNavigationMenuComponent } from './components/side-navigation-menu/side-navigation-menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { WizardComponent } from './wizard/wizard.component';
import { WizardItemDirective } from './wizard/wizard-item.directive';
import { RouterModule } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CodePostalComponent } from './components/code-postal/code-postal.component';
import { PaysComponent } from './components/pays/pays.component';
import { CodePostalSelectComponent } from './components/code-postal-select/code-postal-select.component';
import { PaysSelectComponent } from './components/pays-select/pays-select.component';
import { TypeDechetComponent } from './components/type-dechet/type-dechet.component';
import { TypeDechetSelectComponent } from './components/type-dechet-select/type-dechet-select.component';
import { TypeDechetRWComponent } from './components/type-dechet-rw/type-dechet-rw.component';
import { TypeDechetRwSelectComponent } from './components/type-dechet-rw-select/type-dechet-rw-select.component';
import { UnitesMesureSelectComponent } from './components/unites-mesure-select/unites-mesure-select.component';
import { UniteMesureComponent } from './components/unite-mesure/unite-mesure.component';
import { ParcComponent } from './components/parc/parc.component';
import { ParcSelectComponent } from './components/parc-select/parc-select.component';
import { ExutoireComponent } from './components/exutoire/exutoire.component';
import { ExutoireSelectComponent } from './components/exutoire-select/exutoire-select.component';
import { ConteneurComponent } from './components/conteneur/conteneur.component';
import { ZoneGeographiqueComponent } from './components/zone-geographique/zone-geographique.component';
import { ZoneGeographiqueSelectComponent } from './components/zone-geographique-select/zone-geographique-select.component';
import { TypeConteneurMobileComponent } from './components/type-conteneur-mobile/type-conteneur-mobile.component';
import { TypeConteneurMobileSelectComponent } from './components/type-conteneur-mobile-select/type-conteneur-mobile-select.component';
import { EcranDetailComponent } from './components/ecran-detail/ecran-detail.component';
import { DesactivatePopupComponent } from './components/desactivate-popup/desactivate-popup.component';
import { DesactivateInfosComponent } from './components/desactivate-infos/desactivate-infos.component';
import { PictogrammeComponent } from './components/pictogramme/pictogramme.component';
import { PictogrammeSelectComponent } from './components/pictogramme-select/pictogramme-select.component';
import { TypeIncidentSelectComponent } from './components/type-incident-select/type-incident-select.component';
import { TypeIncidentComponent } from './components/type-incident/type-incident.component';
import { TauxRemplissageComponent } from './components/taux-remplissage/taux-remplissage.component';
import { TauxRemplissageSelectComponent } from './components/taux-remplissage-select/taux-remplissage-select.component';
import { DesactivateInfosPopupComponent } from './components/desactivate-infos-popup/desactivate-infos-popup.component';
import { CategorieDocumentSelectComponent } from './components/categorie-document-select/categorie-document-select.component';
import { CategorieDocumentComponent } from './components/categorie-document/categorie-document.component';
import { NgxsModule } from '@ngxs/store';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { TypesAccesComponent } from './components/types-acces/types-acces.component';
import { FormesJuridiquesCellComponent } from './components/formes-juridiques/formes-juridiques.component';
import { ConteneurSelectComponent } from './components/conteneur-select/conteneur-select.component';
import { TransporteurSelectComponent } from './components/transporteur-select/transporteur-select.component';
import { TransporteurComponent } from './components/transporteur/transporteur.component';
import { DispatchExutoireSelectComponent } from './components/dispatch-exutoire-select/dispatch-exutoire-select.component';
import { DispatchExutoireComponent } from './components/dispatch-exutoire/dispatch-exutoire.component';
import { DispatchTransporteurComponent } from './components/dispatch-transporteur/dispatch-transporteur.component';
import { DispatchTransporteurSelectComponent } from './components/dispatch-transporteur-select/dispatch-transporteur-select.component';
import { QrCodesBarresComponent } from './components/qr-codes-barres/qr-codes-barres.component';
import { VisiteursStore } from 'src/modules/visiteurs/state/visiteurs.store';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxBarcodeModule } from 'ngx-barcode';
import { WebhookEvenementSelectComponent } from './components/webhook-evenement-select/webhook-evenement-select.component';
import { WebhookEvenementComponent } from './components/webhook-evenement/webhook-evenement.component';
import { WebhookTypeComponent } from './components/webhook-type/webhook-type.component';
import { WebhookTypeSelectComponent } from './components/webhook-type-select/webhook-type-select.component';
import { VisitesStore } from 'src/modules/visites/state/visites.store';
import { IncidentPhotosPopupComponent } from './components/incident-photos-popup/incident-photos-popup.component';
import { DxGalleryModule } from 'devextreme-angular';
import { ApplicationPipesModule } from '../application-pipes/application-pipes.module';
import { AuthImagePipe } from 'src/core/application-pipes/auth-image';
import { ExcludeInfosPopupComponent } from './components/exclude-infos-popup/exclude-infos-popup.component';
import { FormeJuridiqueSelectComponent } from './components/forme-juridique-select/forme-juridique-select.component';
import { TypesAccesSelectComponent } from './components/types-acces-select/types-acces-select.component';
import { ArticleTypeComponent } from './components/article-type/article-type.component';
import { ArticleTypeSelectComponent } from './components/article-type-select/article-type-select.component';
import { ArticleSelectComponent } from './components/article-select/article-select.component';
import { EmplacementSelectComponent } from './components/emplacement-select/emplacement-select.component';
import { EmplacementComponent } from './components/emplacement/emplacement.component';
import { StatutCommandeComponent } from './components/statut-commande/statut-commande.component';
import { ReleveCompteurTypeComponent } from './components/releve-compteur-type/releve-compteur-type.component';
import { ReleveCompteurTypeSelectComponent } from './components/releve-compteur-type-select/releve-compteur-type-select.component';
import { InterventionTypeComponent } from './components/intervention-type/intervention-type.component';
import { InterventionTypeSelectComponent } from './components/intervention-type-select/intervention-type-select.component';
import { InterventionStatutComponent } from './components/intervention-statut/intervention-statut.component';
import { StatutChecklistComponent } from './components/statut-checklist/statut-checklist.component';
import { LanguesPopupComponent } from './components/langues-popup/langues-popup.component';
import { EvacuationStatusComponent } from './components/evacuation-status/evacuation-status.component';
import { EvacuationStatusSelectComponent } from './components/evacuation-status-select/evacuation-status-select.component';
import { TypeEvacuationComponent } from './components/type-evacuation/type-evacuation.component';
import { TypeEvacuationSelectComponent } from './components/type-evacuation-select/type-evacuation-select.component';
import { RapportStatusComponent } from './components/rapport-status/rapport-status.component';
import { NettoyageStatutComponent } from './components/nettoyage-statut/nettoyage-statut.component';
import { StartupComponent } from './components/startup/startup.component';
import { ThemeSelectComponent } from './components/theme-select/theme-select.component';
import { ThemeComponent } from './components/theme/theme.component';
import { CustomNumberBoxDataGridComponent } from './components/custom-number-box-data-grid/custom-number-box-data-grid.component';
import { ParcMultiSelectComponent } from './components/parc-multi-select/parc-multi-select.component';
import { ParcMultiComponent } from './components/parc-multi/parc-multi.component';
import { PhotoSelectComponent } from './components/photo-select/photo-select.component';
import { SelectPhotoPopupComponent } from './components/select-photo-popup/select-photo-popup.component';
import { PhotosPdaDatagridComponent } from './components/select-photo-popup/datagrid/photospda.datagrid.component';
import { DegatsTypeSelectComponent } from './components/degats-type-select/degats-type-select.component';
import { DegatsTypeComponent } from './components/degats-type/degats-type.component';
import { TypeElementStockSelectComponent } from './components/type-element-stock-select/type-element-stock-select.component';
import { TypeElementStockComponent } from './components/type-element-stock/type-element-stock.component';
import { RapportIncidentStatusComponent } from './components/rapport-incident-status/rapport-incident-status.component';
import { RapportIncidentTypeSelectComponent } from './components/rapport-incident-type-select/rapport-incident-type-select.component';
import { RapportIncidentTypeComponent } from './components/rapport-incident-type/rapport-incident-type.component';
import { RapportIncidentTypeDetailComponent } from './components/rapport-incident-type-detail/rapport-incident-type-detail.component';
import { RapportIncidentTypeDetailSelectComponent } from './components/rapport-incident-type-detail-select/rapport-incident-type-detail-select.component';
import { RapportIncidentLieuMultiSelectComponent } from './components/rapport-incident-lieu-multi-select/rapport-incident-lieu-multi-select.component';
import { RapportIncidentSecoursMultiSelectComponent } from './components/rapport-incident-secours-multi-select/rapport-incident-secours-multi-select.component';
import { RapportIncidentMaterielSelectComponent } from './components/rapport-incident-materiel-select/rapport-incident-materiel-select.component';
import { UtilisateurComponent } from './components/utilisateur/utilisateur.component';
import { UtilisateurSelectComponent } from './components/utilisateur-select/utilisateur-select.component';
import { ActionCorrectiveComponent } from './components/action-corrective/action-corrective.component';
import { ActionCorrectiveSelectComponent } from './components/action-corrective-select/action-corrective-select.component';
import { OpenStreetMapComponent } from './components/open-street-map/open-street-map.component';

@NgModule({
  declarations: [
    SingleCardComponent,
    SideNavComponent,
    HeaderComponent,
    UserPanelComponent,
    SideNavigationMenuComponent,
    FooterComponent,
    WizardComponent,
    WizardItemDirective,
    NotFoundComponent,
    CodePostalComponent,
    PaysComponent,
    CodePostalSelectComponent,
    PaysSelectComponent,
    TypeDechetComponent,
    TypeDechetSelectComponent,
    TypeDechetRWComponent,
    TypeDechetRwSelectComponent,
    UnitesMesureSelectComponent,
    UniteMesureComponent,
    ParcComponent,
    ParcSelectComponent,
    ExutoireComponent,
    ExutoireSelectComponent,
    ConteneurComponent,
    ConteneurSelectComponent,
    ZoneGeographiqueComponent,
    ZoneGeographiqueSelectComponent,
    TypeConteneurMobileComponent,
    TypeConteneurMobileSelectComponent,
    EcranDetailComponent,
    DesactivatePopupComponent,
    DesactivateInfosComponent,
    PictogrammeComponent,
    PictogrammeSelectComponent,
    TypeIncidentSelectComponent,
    TypeIncidentComponent,
    TauxRemplissageComponent,
    TauxRemplissageSelectComponent,
    DesactivateInfosPopupComponent,
    CategorieDocumentSelectComponent,
    CategorieDocumentComponent,
    TypesAccesComponent,
    FormesJuridiquesCellComponent,
    ConteneurSelectComponent,
    TransporteurSelectComponent,
    TransporteurComponent,
    DispatchExutoireSelectComponent,
    DispatchExutoireComponent,
    DispatchTransporteurComponent,
    DispatchTransporteurSelectComponent,
    QrCodesBarresComponent,
    WebhookEvenementSelectComponent,
    WebhookEvenementComponent,
    WebhookTypeComponent,
    WebhookTypeSelectComponent,
    IncidentPhotosPopupComponent,
    ExcludeInfosPopupComponent,
    FormeJuridiqueSelectComponent,
    TypesAccesSelectComponent,
    ArticleTypeComponent,
    ArticleTypeSelectComponent,
    ArticleSelectComponent,
    EmplacementSelectComponent,
    EmplacementComponent,
    StatutCommandeComponent,
    ReleveCompteurTypeComponent,
    ReleveCompteurTypeSelectComponent,
    InterventionTypeComponent,
    InterventionTypeSelectComponent,
    InterventionStatutComponent,
    StatutChecklistComponent,
    LanguesPopupComponent,
    EvacuationStatusComponent,
    EvacuationStatusSelectComponent,
    TypeEvacuationComponent,
    TypeEvacuationSelectComponent,
    RapportStatusComponent,
    NettoyageStatutComponent,
    StartupComponent,
    ThemeSelectComponent,
    ThemeComponent,
    CustomNumberBoxDataGridComponent,
    ParcMultiSelectComponent,
    ParcMultiComponent,
    PhotoSelectComponent, 
    SelectPhotoPopupComponent,
    PhotosPdaDatagridComponent,
    DegatsTypeSelectComponent,
    DegatsTypeComponent,
    TypeElementStockSelectComponent,
    TypeElementStockComponent,
    RapportIncidentStatusComponent,
    RapportIncidentTypeSelectComponent,
    RapportIncidentTypeComponent,
    RapportIncidentTypeDetailComponent,
    RapportIncidentTypeDetailSelectComponent,
    RapportIncidentLieuMultiSelectComponent,
    RapportIncidentSecoursMultiSelectComponent,
    RapportIncidentMaterielSelectComponent,
    UtilisateurComponent,
    UtilisateurSelectComponent,
    ActionCorrectiveComponent,
    ActionCorrectiveSelectComponent,
    OpenStreetMapComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DxSharedModule,
    TranslateModule,
    DxGalleryModule,
    RouterModule,
    NgxsModule.forFeature([
      ControlPanelStore,
      VisiteursStore,
      VisitesStore
    ]),
    QRCodeModule,
    NgxBarcodeModule,
    ApplicationPipesModule
  ],
  exports: [
    SingleCardComponent,
    SideNavComponent,
    FooterComponent,
    WizardComponent,
    WizardItemDirective,
    CodePostalComponent,
    CodePostalSelectComponent,
    PaysComponent,
    PaysSelectComponent,
    TypeDechetComponent,
    TypeDechetSelectComponent,
    TypeDechetRWComponent,
    TypeDechetRwSelectComponent,
    UniteMesureComponent,
    UnitesMesureSelectComponent,
    ParcComponent,
    ParcSelectComponent,
    ExutoireComponent,
    ExutoireSelectComponent,
    ConteneurComponent,
    ConteneurSelectComponent,
    ZoneGeographiqueComponent,
    ZoneGeographiqueSelectComponent,
    TypeConteneurMobileComponent,
    TypeConteneurMobileSelectComponent,
    EcranDetailComponent,
    DesactivatePopupComponent,
    DesactivateInfosComponent,
    PictogrammeComponent,
    PictogrammeSelectComponent,
    TypeIncidentSelectComponent,
    TypeIncidentComponent,
    TauxRemplissageComponent,
    TauxRemplissageSelectComponent,
    DesactivateInfosPopupComponent,
    CategorieDocumentSelectComponent,
    CategorieDocumentComponent,
    TypesAccesComponent,
    FormesJuridiquesCellComponent,
    ConteneurSelectComponent,
    TransporteurSelectComponent,
    TransporteurComponent,
    DispatchExutoireSelectComponent,
    DispatchExutoireComponent,
    DispatchTransporteurComponent,
    DispatchTransporteurSelectComponent,
    QrCodesBarresComponent,
	  WebhookEvenementComponent,
	  WebhookEvenementSelectComponent,
    WebhookTypeComponent,
    WebhookTypeSelectComponent,
    IncidentPhotosPopupComponent,
    ExcludeInfosPopupComponent,
    FormeJuridiqueSelectComponent,
    TypesAccesSelectComponent,
    ArticleTypeComponent,
    ArticleTypeSelectComponent,
    ArticleSelectComponent,
    EmplacementSelectComponent,
    EmplacementComponent,
    StatutCommandeComponent,
    ReleveCompteurTypeComponent,
    ReleveCompteurTypeSelectComponent,
    InterventionTypeComponent,
    InterventionTypeSelectComponent,
    InterventionStatutComponent,
    StatutChecklistComponent,
    LanguesPopupComponent,
    InterventionStatutComponent,
    EvacuationStatusComponent,
    EvacuationStatusSelectComponent,
    TypeEvacuationComponent,
    TypeEvacuationSelectComponent,
    RapportStatusComponent,
    NettoyageStatutComponent,
    ThemeSelectComponent,
    ThemeComponent,
    CustomNumberBoxDataGridComponent,
    ParcMultiSelectComponent,
    ParcMultiComponent,
    PhotoSelectComponent,
    SelectPhotoPopupComponent,
    PhotosPdaDatagridComponent,
    DegatsTypeSelectComponent,
    DegatsTypeComponent,
    TypeElementStockSelectComponent,
    TypeElementStockComponent,
    RapportIncidentStatusComponent,
    RapportIncidentTypeSelectComponent,
    RapportIncidentTypeComponent,
    RapportIncidentTypeDetailComponent,
    RapportIncidentTypeDetailSelectComponent,
    RapportIncidentLieuMultiSelectComponent,
    RapportIncidentMaterielSelectComponent,
    RapportIncidentSecoursMultiSelectComponent,
    UtilisateurComponent,
    UtilisateurSelectComponent,
    ActionCorrectiveComponent,
    ActionCorrectiveSelectComponent,
    OpenStreetMapComponent
  ]
})
export class LayoutsModule { }
